{
  "action": {
    "label": "Azione"
  },
  "actionType": {
    "label": "Tipo di azione",
    "value": {
      "alert": "Avviso",
      "dvtm": "DVTM",
      "external_platform": "Piattaforma esterna",
      "group": "Gruppo",
      "iam": "IAM",
      "platform": "Piattaforma",
      "profile": "Profilo",
      "sector": "Rete",
      "talq_gateway": "Gateway TALQ",
      "user": "Utente"
    }
  },
  "export": {
    "error": "Si è verificato un errore durante la generazione del file CSV",
    "label": "Esporta",
    "tooltip": "Selezionare le linee per poterle esportare in formato CSV"
  },
  "eventType": {
    "label": "Tipo di evento",
    "value": {
      "cyber": "Cyber",
      "device": "Apparato",
      "device_fleet": "Parco di apparati",
      "system": "Sistema"
    }
  },
  "level": {
    "label": "Livello di informazioni.",
    "value": {
      "info": "Informazioni",
      "warning": "Avviso",
      "error": "Errore",
      "critical": "Critico"
    }
  },
  "timestamp": {
    "label": "Marcatura temporale"
  },
  "filters": {
    "actions": {
      "placeholder": "Ricerca per azione",
      "empty": "Non è stata trovata nessuna azione",
      "actionFound": "Nessuna azione trovata | {count} azione trovata | {count} azioni trovate"
    },
    "applications": {
      "declination": {
        "empty": "Nessuna applicazione"
      },
      "label": "Applicazione",
      "placeholder": "Ricerca per applicazione",
      "type": {
        "empty": "Nessun tipo"
      }
    },
    "clear": {
      "label": "Eliminare i filtri"
    },
    "componentId": {
      "label": "Identificativo componente",
      "value": {
        "all": "Tutti"
      }
    },
    "dropdown": {
      "applyAsAFilter": "Applicare come filtro",
      "button": {
        "label": "Filtri",
        "title": "Visualizzare i filtri"
      },
      "properties": {
        "device": "Proprietà dell’apparato",
        "email_address": "Proprietà dell’e-mail",
        "gateway": "Proprietà del gateway",
        "group": "Proprietà del gruppo",
        "platform": "Proprietà della piattaforma",
        "profile": "Proprietà del profilo",
        "sector": "Proprietà della rete",
        "user": "Proprietà dell’utente",
        "pki_config": "Proprietà PKI",
        "interface": "Proprietà interfaccia"
      }
    },
    "entityClass": {
      "label": "Categoria autore o attività",
      "value": {
        "device": "Apparato",
        "email_address": "Indirizzo e-mail",
        "gateway": "Gateway",
        "group": "Gruppo",
        "platform": "Piattaforma",
        "profile": "Profilo",
        "role": "Ruolo",
        "sector": "Rete",
        "user": "Utente"
      }
    },
    "entity": {
      "label": "Autore o attività"
    },
    "sortBy": {
      "label": "Classificazione",
      "value": {
        "datetime": "Cronologico"
      }
    },
    "sortDirection": {
      "label": "Ordine",
      "value": {
        "asc": "Crescente",
        "desc": "Decrescente"
      }
    },
    "startDate": {
      "label": "Data di inizio"
    },
    "status": {
      "label": "Errore"
    },
    "timestamp": {
      "formatter": "DD/MM/YYYY",
      "periodSeparator": "a",
      "placeholder": "Selezionare un periodo"
    },
    "users": {
      "placeholder": "Cerca utenti",
      "header": "Utenti"
    },
    "assetClass": {
      "label": "Categoria di attivi",
      "value": {
        "device": "Apparato",
        "email_address": "Indirizzo e-mail",
        "gateway": "Gateway",
        "group": "Gruppo",
        "platform": "Piattaforma",
        "profile": "Profilo",
        "sector": "Rete",
        "user": "Utente"
      }
    },
    "authorClass": {
      "label": "Categoria autore",
      "value": {
        "device": "Apparato",
        "email_address": "Indirizzo e-mail",
        "gateway": "Gateway",
        "group": "Gruppo",
        "platform": "Piattaforma",
        "profile": "Profilo",
        "sector": "Rete",
        "user": "Utente"
      }
    },
    "devices": {
      "header": "Apparati",
      "model": {
        "empty": "Nessun modello"
      },
      "placeholder": "Cerca apparati",
      "type": {
        "empty": "Nessun tipo"
      }
    },
    "actionTypes": {
      "placeholder": "Cerca tipi di azione",
      "empty": "Nessun tipo di azione trovato",
      "actionTypesFound": "Nessun tipo di azione trovato | {count} tipo di azione trovato | {count} tipi di azione trovati"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/YYYY HH:mm:ss"
      },
      "label": {
        "label": "Etichetta"
      }
    },
    "empty": "Non è stato trovato nessun registro salvato",
    "unknown": "sconosciuto"
  },
  "origin": {
    "label": "Origine",
    "values": {
      "mobileApplication": "Applicazione mobile",
      "device": "Apparato",
      "thirdPartyApplication": "Applicazione di terze parti",
      "lxConnect": "LX CONNECT"
    }
  }
}
